import type * as Core from 'app/core/models/essette-api';
import { createSimpleCache, CreateSimpleCacheOptions } from 'app/shared/lib/cache/create-simple-cache';
import { Sorting } from 'app/shared/lib/essette-site';

export interface IDocumentsCacheState {
    documents: ReadonlyArray<Core.Document>;
    sorting?: Sorting;
    resultCount?: number;
    page?: number;
    targetId?: string;
    includeInactive?: boolean;
}

export const createDocumentsCache = (opts: CreateSimpleCacheOptions<IDocumentsCacheState>) => createSimpleCache<IDocumentsCacheState>({ documents: [] }, opts);

export type IDocumentsCache = ReturnType<typeof createDocumentsCache>;
